// Configuração do Supabase
export const supabaseConfig = {
  url: "https://bzywoappbauepfgmjqmj.supabase.co",
  key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ6eXdvYXBwYmF1ZXBmZ21qcW1qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgxMjAwNTAsImV4cCI6MjA5MzY5NjA1MH0.Mi9oQNstsojYm20K4WkLDloyE0SYmcZ27G3wks_rScA"
}

// Configuração de ambiente
// isOnline será true apenas quando o Supabase estiver configurado e acessível
// Por padrão, opera em modo local até que a conexão seja verificada
let _isOnline = false

export function setIsOnline(value) {
  _isOnline = value
}

export function getIsOnline() {
  return _isOnline
}

export const isOnline = new Proxy({ value: false }, {
  get(target, prop) {
    if (prop === 'valueOf') return () => _isOnline
    if (prop === Symbol.toPrimitive) return () => _isOnline
    return _isOnline
  }
})

// Verificar conexão com Supabase ao iniciar
export async function checkSupabaseConnection() {
  try {
    const response = await fetch(`${supabaseConfig.url}/rest/v1/usuarios?limit=1`, {
      method: 'GET',
      headers: {
        'apikey': supabaseConfig.key,
        'Authorization': `Bearer ${supabaseConfig.key}`,
        'Content-Type': 'application/json'
      }
    })
    
    if (response.ok) {
      _isOnline = true
      console.log('[Supabase] Conexão verificada: Online')
    } else {
      _isOnline = false
      console.log('[Supabase] Conexão verificada: Offline (status:', response.status, ')')
    }
    
    return _isOnline
  } catch (error) {
    _isOnline = false
    console.log('[Supabase] Conexão falhou:', error.message)
    return false
  }
}

// Tabelas do Supabase
export const tables = {
  usuarios: 'usuarios',
  produtos: 'produtos',
  funcionarios: 'funcionarios',
  movimentacoes: 'movimentacoes',
  compras: 'compras_pendentes',
  pedidos: 'pedidos_ativo',
  historico: 'historico_pedidos'
}

// Mapeamento de nomes de tabelas para sincronização
export const tableSyncNames = {
  'usuarios': 'usuarios',
  'produtos': 'produtos',
  'funcionarios': 'funcionarios',
  'movimentacoes': 'movimentacoes',
  'compras_pendentes': 'compras_pendentes',
  'pedidos_ativo': 'pedidos_ativo'
}

// Configuração de sincronização
export const syncConfig = {
  enabled: isOnline,
  autoSync: true,
  syncInterval: 30000, // 30 segundos
  retryAttempts: 3,
  retryDelay: 5000 // 5 segundos
}
